export default {
  'setVariable.title': 'Set Variables',

  'setVariable.form.sourceForm': 'Source Form',
  'setVariable.form.sourceField': 'Source Field',
  'setVariable.form.formFieldValueSource': 'Field Value Source',
  'setVariable.form.variable': 'Variable',

  'setVariable.form.valueSource': 'Value Source',
  'setVariable.form.sourceVariable': 'Source Variable',
  'setVariable.form.form': 'Form',
  'setVariable.form.field': 'Field',
  'setVariable.form.formula': 'Formula',
  'setVariable.form.fixedValue': 'Fixed Value',
  'setVariable.form.internalField': 'Internal Field',

  'setVariable.form.parameterValueFilterComparisonOperator': 'Filter Operator',
  'setVariable.form.parameterValueFilter': 'Parameter Filter Value',

  'setVariable.form.formFieldValueDestination': 'Field Value Destination',

  'setVariable.form.tableParameterName': 'List Parameter Name',
  'setVariable.form.parameterName': 'Parameter Name',
  'setVariable.form.attachmentFileName': 'Attachment Name',
  'setVariable.form.attachmentContentType': 'Content Type',

  'setVariable.form.select.FormField': 'Form / Field',
  'setVariable.form.select.Variable': 'Variable',

  'setVariable.form.select.Formula': 'Formula',
  'setVariable.form.select.FixedValue': 'Fixed Value',
  'setVariable.form.select.InternalField': 'Internal Field',
  'setVariable.form.select.IterationStepData': 'Iteration / Data',
  'setVariable.form.select.GeneratedDocument': 'Generated Document',

  'setVariable.form.select.FieldValue': 'Display Value',
  'setVariable.form.select.FieldSearchValue': 'Search Value',
};
